<ion-content class="container">
  <ion-row *ngIf="!router.url.includes('Setup')">
    <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12" class="pl-15 pr-0 pb-0">
      <div class="borderbottomForTab" *ngIf="!router.url.includes('Setup')">
        <mat-tab-group #tabGroup class="pt-10 pr-10" [selectedIndex]="selectedTypeTabIndex"
          (selectedTabChange)="tabTypeChanged($event)">
          <mat-tab label="Dashboard">
            <ng-template mat-tab-label>
              <span class="tab-label" style="display: contents;">
                <span class="material-icons mr-10">
                  speed
                </span>Dashboard</span>
            </ng-template>
          </mat-tab>
          <mat-tab label="360 Review Master"
            *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
            <ng-template mat-tab-label>
              <span class="tab-label" style="display: contents;">
                <span class="material-icons mr-10">
                  group
                </span>360 Review Master</span>
            </ng-template>
          </mat-tab>
          <mat-tab label="Participate in 360 Review" *ngIf="loggedInUserRole == 'Employee' || loggedInUserRole == 'HOD' ||
          loggedInUserRole == 'Manager'">
            <ng-template mat-tab-label>
              <span class="tab-label" style="display: contents;">
                <span class="material-icons mr-10">
                  account_balance_wallet
                </span>Participate in 360 Review</span>
            </ng-template>
          </mat-tab>
          <mat-tab label="Reports">
            <ng-template mat-tab-label>
              <span class="tab-label" style="display: contents;">
                <span class="material-icons mr-10">
                  description
                </span>Reports</span>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>
    </ion-col>
    <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="" class="borderbottomForTab pl-10 pt-10 pr-10 "
      *ngIf="!router.url.includes('Setup') && (loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD') && !mobileResponsiveService.hideForTabletAndBelow">
      <div class="center-content float-right">
        <div>
          <span class="cp fs-14 fs_12ForMobile link font_regular center-content mr-20 logs-link"
            (click)="onClickLogs('Logs')">
            <img src="././assets/icon/logsIcon.svg"><u>Logs</u></span>
        </div>
        <div>
          <button type="button" class="btn_one fs-14 fs_12ForMobile float-right center-content mr-5 setup-btn"
            [style.background-color]="buttonColorName" (click)="onClickSetup('Setup')">
            <span class="material-icons fs-20 mr-5">settings</span>Setup</button>
        </div>
      </div>
    </ion-col>
  </ion-row>


  <!-- --------------------------------------SetUp----------------------------------- -->

  <div class="modal fade" [style.display]="showSetupPopup? 'block' : 'none'"
    *ngIf="!mobileResponsiveService.hideForTabletAndBelow">
    <div class="modal-dialog">
      <div class="modal-content">
        <ion-row class="p-0 headerBreadcrumb">
          <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4" class="center-content">
            <div class="d-flex">
              <img src="././assets/icon/backArrow.svg" class="cp" (click)="onClickRedirectToDashboard()">
              <label class="font_semibold fs-16 fs_14ForMobile ml-10 mt-5 black_color"
                (click)="onClickRedirectToDashboard()">
                <span class="cp">360 Review</span> / <span [style.color]="buttonColorName">Setup</span></label>
            </div>
          </ion-col>
          <ion-col size-sm="8" size-md="8" size-lg="8" size-xs="8" class="text-right">
            <div class="d-inline-flex p-5">
              <button (click)="onClickCancelSetup()" type="button" class="back_btn mr-10">Cancel</button>
              <button [disabled]="isPublished" [ngClass]="{'disableBtn' : isPublished}" type="button"
                class="ess_Btn fs-14 fs_12ForMobile mr-10" [style.background-color]="buttonColorName"
                (click)="onClickSaveSetup()">Save</button>
              <button [disabled]="isPublished" [ngClass]="{'disableBtn' : isPublished || isCheckSave}" type="button"
                class="ess_Btn fs-14 fs_12ForMobile mr-10" [style.background-color]="buttonColorName"
                (click)="onClickPublishBtn()">Publish</button>
            </div>
          </ion-col>
        </ion-row>
      </div>

      <div class="modal-body p-20">
        <div class="cardBox mb-20">
          <div class="headingOfShowBox font_medium fs-14 fs_12ForMobile">
            <ion-row class="p-0">
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="font_bold fs-14 fs_12ForMobile ml-5">360 Review</div>
              </ion-col>
            </ion-row>
          </div>
          <div class="p-10">
            <ion-row>
              <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
                <ion-row>
                  <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
                    <div class="formLabelSemiBoldfs14 mb-5">Year</div>
                    <mat-form-field class="w-100 mat-height40 mat-input-style">
                      <mat-select placeholder="Select Year" [(ngModel)]="selectedYear"
                        (selectionChange)="onChange360Year()">
                        <mat-option *ngFor="let item of yearsOfCompany"
                          [value]="item.year">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ion-col>
                  <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
                    <div class="formLabelSemiBoldfs14 mb-25"></div>
                    <div class="createServeyBtn">
                      <button class="btn_one fs-14 fs_12ForMobile" [style.background-color]="buttonColorName"
                        [disabled]="selectedYear !== currentFiscalYear"
                        (click)="onClickOpenCreateReviewPopup('Create 360 Review')">+ Create 360 Review</button>
                    </div>
                  </ion-col>
                  <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
                    <div class="formLabelSemiBoldfs14 mb-5">360 Review</div>
                    <mat-form-field class="w-100 mat-height40 mat-input-style">
                      <mat-select placeholder="Select Review" [(ngModel)]="selectedReviewID"
                        (selectionChange)="getReviewByID()">
                        <mat-option *ngFor="let item of listofReviewNames" [value]="item.id">{{item.name}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ion-col>
                </ion-row>
              </ion-col>
            </ion-row>
          </div>
        </div>

        <div class="cardBox mb-20" *ngIf="showDataSection">
          <div class="headingOfShowBox font_medium fs-14 fs_12ForMobile">
            <ion-row class="p-0">
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="font_bold fs-14 fs_12ForMobile ml-5">Setup</div>
              </ion-col>
            </ion-row>
          </div>
          <div class="p-10">
            <ion-row>
              <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
                <div>
                  <table class="table-container">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>Status</th>
                        <th *ngIf="!isPublished || selectedReviewStatus == 'Active'"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <label *ngIf="!isEditActive"
                            class="fs-14 fs_12ForMobile regular">{{selectedReviewName}}</label>
                          <mat-form-field *ngIf="isEditActive" class="custom-input w-80 mat-height40 mat-input-style">
                            <input matInput placeholder="Review"
                              [disabled]="selectedReviewStatus == 'Active' ||isPastDate(selectedReviewEndDate)"
                              class="font_regular" [(ngModel)]="selectedReviewName">
                          </mat-form-field>
                        </td>
                        <td>
                          <label *ngIf="!isEditActive" class="fs-14 fs_12ForMobile regular">{{selectedReviewStartDate |
                            date:'dd-MM-yyyy'}}</label>
                          <mat-form-field *ngIf="isEditActive" class="custom-input w-80 mat-height40 mat-input-style">
                            <input matInput dateInput
                              [disabled]="selectedReviewStatus == 'Active' ||isPastDate(selectedReviewEndDate)"
                              [matDatepicker]="startDatePicker" placeholder="DD/MM/YYYY"
                              [(ngModel)]="selectedReviewStartDate" [min]="selectedReviewStartDate">
                            <mat-datepicker-toggle matIconSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #startDatePicker></mat-datepicker>
                          </mat-form-field>
                        </td>
                        <td>
                          <label *ngIf="!isEditActive" class="fs-14 fs_12ForMobile regular">{{selectedReviewEndDate |
                            date:'dd-MM-yyyy'}}</label>
                          <mat-form-field *ngIf="isEditActive" class="custom-input w-80 mat-height40 mat-input-style">
                            <input matInput dateInput [matDatepicker]="endDatePicker" placeholder="DD/MM/YYYY"
                              [(ngModel)]="selectedReviewEndDate" [min]="selectedReviewStartDate"
                              [disabled]="isPastDate(selectedReviewEndDate)">
                            <mat-datepicker-toggle matIconSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #endDatePicker></mat-datepicker>
                          </mat-form-field>
                        </td>
                        <td class="tableDisableTd">{{selectedReviewStatus}}</td>
                        <td class="tableDisableTd"
                          *ngIf="!isPublished || selectedReviewStatus == 'Active' || selectedReviewStatus == 'Published_Not_Started'">
                          <span *ngIf="isEditActive" (click)="closeSurveyEdit()"
                            class="material-icons close p-10 cp fs-20">close</span>
                          <img *ngIf="!isEditActive" class="ml-5 cp imgEdit" title="Edit" (click)="editSurvey()"
                            src="././assets/icon/edit.png"
                            [ngClass]="{ 'disabled-img': isPastDate(selectedReviewEndDate) }">
                          <span *ngIf="isEditActive" (click)="updateReview()"
                            class="material-icons link p-10 cp fs-20">check</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </ion-col>
            </ion-row>

            <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="fs-14 fs_12ForMobile font_semibold mt-20">Can HR admin see Reports/ dashboards <span
                    class="red-cl">&nbsp;*</span></div>
                <div class="mt-10">
                  <mat-radio-group aria-label="Select an option" [(ngModel)]="isShowDashboardToHR"
                    class="fs-14 fs_12ForMobile font_semibold" [class.readonly-checkbox]="isPublished">
                    <mat-radio-button [value]="true">Yes</mat-radio-button>
                    <mat-radio-button [value]="false" class="pl-10">No</mat-radio-button>
                  </mat-radio-group>
                </div>
              </ion-col>
            </ion-row>

            <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="fs-14 fs_12ForMobile font_semibold mt-20">Create Stake Holders <span class="red">*</span>
                </div>
                <div class="fs-14 fs_12ForMobile mt-10 cp"
                  *ngIf="!isShowSaveBtn && stakeHoldersArrayForSetup.length==5 && !isPublished"
                  [style.Color]="buttonColorName" (click)="onAddStakeHolders()">+ Add New</div>
                <div class="fs-14 fs_12ForMobile mt-10 cp" *ngIf="isShowSaveBtn" [style.Color]="buttonColorName"
                  (click)="onSaveStakeHolders()">Save</div>

                <div class="mt-20" *ngIf="isShowSaveBtn">
                  <mat-form-field class="custom-input w-100 mw-sm-250 mat-height40 mat-input-style">
                    <input matInput placeholder="External Customer" readonly class="font_regular">
                  </mat-form-field>
                </div>

                <ion-row>
                  <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                    <!-- <table class="table-container mt-10">
                      <thead>
                        <tr>
                          <th>Stake Holders</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of stakeHoldersArrayForSetup">
                          <td>
                            {{item.name}}
                            <span *ngIf="item.name=='External Customer'" (click)="deleteExternalCustomer()"
                              class="material-icons red float-right cp fs-20">delete</span>
                          </td>
                        </tr>
                      </tbody>
                    </table> -->

                    <div style="display: flex; flex-wrap: wrap; align-items: center; gap: 30px; margin-top: 10px;">
                      <div *ngFor="let stakeholder of stakeHoldersArrayForSetup" [class.readonly-checkbox]="isPublished">
                        <label>
                          <input type="checkbox" [(ngModel)]="stakeholder.selected"
                            (change)="onStakeholderChange(stakeholder)" />
                          {{ stakeholder.name }}
                        </label>
                      </div>
                    </div>



                  </ion-col>
                </ion-row>
              </ion-col>
            </ion-row>

            <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="fs-14 fs_12ForMobile font_semibold mt-20">Employees to participate in the 360 Review</div>
                <ion-row>
                  <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
                    <div class="mt-10 fs-14 fs_12ForMobile text_grey font_regular">Location <span
                        class="red-cl">&nbsp;*</span></div>
                    <div class="mt-10">
                      <ng-multiselect-dropdown class="w-100" [placeholder]="'Select Location'"
                        [settings]="dropdownSettings" (onSelect)="getBandsListForEssSetup()"
                        (onDeSelect)="onDeSelectLocationSetup()" (onSelectAll)="selectAllLocationSetup($event)"
                        (onDeSelectAll)="onDeSelectAllLocationSetup()" [data]="getLocationList"
                        [(ngModel)]="selectedLocationForSetup">
                      </ng-multiselect-dropdown>
                    </div>
                  </ion-col>

                  <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
                    <div class="mt-10 fs-14 fs_12ForMobile text_grey font_regular">Band <span
                        class="red-cl">&nbsp;*</span></div>
                    <div class="mt-10">
                      <ng-multiselect-dropdown class="w-100" [placeholder]="'Select Band'" [settings]="dropdownSettings"
                        (onSelect)="getGradesListForEssSetup()" (onDeSelect)="onDeSelectBandSetup()"
                        (onSelectAll)="selectAllBandSetup($event)" (onDeSelectAll)="onDeSelectAllBandSetup()"
                        [data]="getBandList" [(ngModel)]="selectedBandForSetup">
                      </ng-multiselect-dropdown>
                    </div>
                  </ion-col>

                  <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
                    <div class="mt-10 fs-14 fs_12ForMobile text_grey font_regular">Grade <span
                        class="red-cl">&nbsp;*</span></div>
                    <div class="mt-10">
                      <ng-multiselect-dropdown class="w-100" [placeholder]="'Select Grade'"
                        [settings]="dropdownSettings" (onSelect)="getDeptListForEssSetup()"
                        (onDeSelect)="onDeSelectGradeSetup()" (onSelectAll)="selectAllGradeSetup($event)"
                        (onDeSelectAll)="onDeSelectAllGradeSetup()" [data]="getGradeList"
                        [(ngModel)]="selectedGradeForSetup">
                      </ng-multiselect-dropdown>
                    </div>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
                    <div class="mt-10 fs-14 fs_12ForMobile text_grey font_regular">Function<span
                        class="red-cl">&nbsp;*</span></div>
                    <div class="mt-10">
                      <ng-multiselect-dropdown class="w-100" [placeholder]="'Select Function'"
                        [settings]="dropdownSettings" (onSelect)="onSelectFunctionSetup()"
                        (onDeSelect)="onDeSelectFunctionSetup()" (onSelectAll)="selectAllFunctionSetup($event)"
                        (onDeSelectAll)="onDeSelectAllFunctionSetup()" [data]="getFunctionList"
                        [(ngModel)]="selectedFunctionForSetup">
                      </ng-multiselect-dropdown>
                    </div>
                  </ion-col>

                  <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
                    <div class="mt-10 fs-14 fs_12ForMobile font_regular">Date of Joining ( Review Cut-Off )<span
                        class="red-cl">&nbsp;*</span></div>
                    <div class="mt-10">
                      <mat-form-field class="custom-input w-100 mat-height40 mat-input-style">
                        <input matInput readonly dateInput [matDatepicker]="dojDatePicker" placeholder="DD/MM/YYYY"
                          [(ngModel)]="reviewDateOfJoining">
                        <mat-datepicker-toggle matIconSuffix [for]="dojDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #dojDatePicker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </ion-col>

                  <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
                    <button type="button" class="btn_one fs-14 fs_12ForMobile mt-35 center-content mr-5"
                      [style.background-color]="buttonColorName"
                      (click)="onClickOpenCreateSurveyPopup('View Employees')">View Employees</button>
                  </ion-col>
                </ion-row>
              </ion-col>
            </ion-row>

            <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="fs-14 fs_12ForMobile font_semibold mt-20">Create Rating</div>
                <div class="mt-10">
                  <ion-row>
                    <ion-col size-sm="12" size-md="8" size-lg="8" size-xs="12">
                      <table class="table-container">
                        <thead>
                          <tr>
                            <th>Question type</th>
                            <th>Rating</th>
                            <th>Rating Definition</th>
                            <th *ngIf="!isPublished"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of ratingList; let i = index">
                            <td>
                              <ng-select [clearable]="false" class="w170 mat mat-height40" placeholder="Select"
                                [(ngModel)]="item.questionType" (change)="onQuestionTypeChange(item,i)">
                                <ng-option [value]="'Rating Based'">Rating Based</ng-option>
                                <ng-option *ngIf="!isOpenEnded" [value]="'Open Ended'">Open Ended</ng-option>
                              </ng-select>
                            </td>
                            <td>
                              <mat-form-field *ngIf="item.questionType == 'Rating Based'"
                                class="custom-input w170 mat-height40 mat-input-style">
                                <input type="number" matInput placeholder="Type here" class="font_regular"
                                  [(ngModel)]="item.rating" (keypress)="validateInputRating($event)">
                              </mat-form-field>
                            </td>
                            <td>
                              <mat-form-field *ngIf="item.questionType == 'Rating Based'"
                                class="custom-input w170 mat-height40 mat-input-style">
                                <input type="text" matInput placeholder="Type here" class="font_regular"
                                  [(ngModel)]="item.ratingDefinition" maxlength="255">
                              </mat-form-field>
                            </td>
                            <td *ngIf="!isPublished">
                              <div class="tableAddRemoveIcon">
                                <img *ngIf="i === ratingList.length - 1" class="cp" title="Add"
                                  src="././assets/icon/Plus_icon.svg" (click)="createRatingAddTableRow()">
                                <img *ngIf="ratingList.length > 1" class="cp ml-5" title="Remove"
                                  src="././assets/icon/Minus_icon.svg" (click)="createRatingRemoveTableRow(i,item)">
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                    </ion-col>
                  </ion-row>
                </div>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
                <div class="fs-14 fs_12ForMobile font_semibold mt-20 mb-20">Select Template</div>
                <!-- <div class="verticle-center mt-20">
                  <div> -->
                <ng-select [clearable]="false" class="w-100 mw-sm-250 mat mat-height40" placeholder="Select"
                  [(ngModel)]="selectedTemplateColorName">
                  <ng-option *ngFor="let item of templateColorList" [value]="item.colorName">
                    <div class="d-flex">
                      <label title="{{item.colorName}} - {{item.stripcolor}}"
                        class="rounded-color-picker firstColorofPicker" [style.background-color]="item.stripcolor">
                      </label>
                      <label title="Background - {{item.backgroundColor}}"
                        class="ml-5 rounded-color-picker firstColorofPicker"
                        [style.background-color]="item.backgroundColor">
                      </label>
                      <span class="ml-10">{{item.colorName}}</span>
                    </div>
                  </ng-option>
                </ng-select>
                <!-- </div>
                </div> -->
              </ion-col>
              <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
                <div class="d-flex">
                  <div>
                    <div class="fs-14 fs_12ForMobile font_semibold mt-20">Reminders <span class="red-cl">&nbsp;*</span>
                    </div>
                    <mat-radio-group aria-label="Select an option" class="fs-14 fs_12ForMobile font_semibold mt-10"
                      [(ngModel)]="onSeletReminderOption"[class.readonly-checkbox]="isPublished">
                      <mat-radio-button [value]="true"> Yes</mat-radio-button>
                      <mat-radio-button [value]="false" class="pl-10">No</mat-radio-button>
                    </mat-radio-group>
                  </div>

                  <div class="ml-30" *ngIf="onSeletReminderOption">
                    <div class="fs-14 fs_12ForMobile font_semibold mt-20">Set Reminders</div>
                    <mat-form-field>
                      <input matInput [(ngModel)]="latestSelectedDate" [matDatepicker]="picker"
                        [value]="latestSelectedDate" (dateChange)="addDate($event.value)" placeholder="Select Dates"
                        [min]="selectedReviewStartDate" [max]="selectedReviewEndDate">
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker [dateClass]="dateClass"></mat-datepicker>
                    </mat-form-field>
                    <!-- <div>
                        <mat-chip *ngFor="let date of selectedDatesForReminder" (removed)="removeDate(date)">
                          {{ date | date: 'dd/MM/yyyy' }}
                          <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                    </div> -->
                  </div>
                </div>
              </ion-col>
            </ion-row>

            <ion-row>
              <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
                <ion-row>
                  <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
                    <div class="fs-14 fs_12ForMobile font_semibold mt-20">Create Email Body</div>
                    <div class="content-box mt-20">
                      <div><img class="w50" src="././assets/icon/mail_Icon.svg" alt="createEmailBody"></div>
                      <button class="btn_one fs-14 fs_12ForMobile" [style.background-color]="buttonColorName"
                        (click)="onClickOpenCreateSurveyPopup('Create Email Body')">{{!isPublished?'+
                        Create':'View'}}</button>
                    </div>
                  </ion-col>
                  <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
                    <div class="fs-14 fs_12ForMobile font_semibold mt-20">Create Instructions</div>
                    <div class="content-box mt-20">
                      <div><img class="w50" src="././assets/icon/instructions_icon.svg" alt="createInstructions"></div>
                      <button class="btn_one fs-14 fs_12ForMobile" [style.background-color]="buttonColorName"
                        (click)="onClickOpenCreateSurveyPopup('Create Instructions')">{{!isPublished?'+
                        Create':'View'}}</button>
                    </div>
                  </ion-col>
                  <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
                    <div class="fs-14 fs_12ForMobile font_semibold mt-20">Submission Email</div>
                    <div class="content-box mt-20">
                      <div><img class="w50" src="././assets/icon/thumb_up_icon.svg" alt="createSubmissionEmial"></div>
                      <button class="btn_one fs-14 fs_12ForMobile" [style.background-color]="buttonColorName"
                        (click)="onClickOpenCreateSurveyPopup('Submission Email')">{{!isPublished?'+
                        Create':'View'}}</button>
                    </div>
                  </ion-col>
                </ion-row>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="fs-14 fs_12ForMobile font_semibold mt-20">Stakeholder Identification <span
                    class="red">*</span></div>
                <div>
                  <button class="btn_one fs-14 fs_12ForMobile center-content mt-20"
                    [style.background-color]="buttonColorName"
                    (click)="onClickOpenCreateReviewPopup('Stakeholder Identification')">Create
                    Stakeholder Indentification</button>
                </div>
              </ion-col>
            </ion-row>

            <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="fs-14 fs_12ForMobile font_semibold mt-20">Create Stakeholder Indentification <span
                    class="red">*</span>
                </div>
                <div>
                  <button class=" fs-14 fs_12ForMobile btn_one mt-20" [style.background-color]="buttonColorName"
                    (click)="onClickOpenCreateReviewPopup('Create Question')">
                    Create Question</button>
                </div>
              </ion-col>
            </ion-row>
          </div>
        </div>
        <div *ngIf="!showDataSection" style="color: red;">
          <p>No data available for the selected year.</p>
        </div>
      </div>
    </div>
  </div>

  <!-- --------------------------------------Dashboard------------------------------------->

  <div class="container" *ngIf="selectedTypeTabName == 'Dashboard'">
    <!-- <ion-row class="verticle-center mt-10">
      <ion-col size="12" size-md="4" 
        *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
        
          <div class="card expense-card h-100" 
              [class.disabled-card]="reviewCounterCount <= 0"
              (click)="reviewCounterCount > 0 && dashboardPopups()">
          <div class="phi-flex-center phi-gap-12">
            <mat-icon class="expense-icon">receipt_long</mat-icon>
            <div class="text-center">
              <p class="fs-12 font_semibold expense-title">360 degree created by HR</p>
              <p class="mt-5 fs-12 font_bold Cerulean-black cp expense-count">
                {{ reviewCounterCount }}
              </p>
            </div>
          </div>
        </div>
      </ion-col>
      <ion-col size="12" size-md="auto">
        <div class="phi-flex-center phi-gap-10">
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <mat-select placeholder="Select Year" [(ngModel)]="selectedYear"
              (selectionChange)="onChange360DashboardYear($event.value)">
              <mat-option *ngFor="let item of yearsOfCompany"
                [value]="item.year">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
            </mat-select>
          </mat-form-field>
           
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <mat-select placeholder="Select Review" [(ngModel)]="selectedReviewGlobalDashboardID"
              (selectionChange)="onChangeGolbalDashboardReview()">
              <mat-option *ngFor="let item of listofReviewNamesActiveAndCompleted" [value]="item.id">
                {{item.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>

        </div>
      </ion-col>
    </ion-row> -->
    <ion-row class="d-flex mt-10">
           <!-- <ion-col size="12" size-md="9" class="phi-flex-end slide-in-right"> -->
        <ion-col size="12" size-md="3">
          <div class="phi-flex-center phi-gap-10 flex-wrap">
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <mat-select placeholder="Select Year" [(ngModel)]="selectedYear"
                (selectionChange)="onChange360DashboardYear($event.value)">
                <mat-option *ngFor="let item of yearsOfCompany"
                  [value]="item.year">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
              </mat-select>
            </mat-form-field>

          
          </div>
        </ion-col>
      <!-- </ion-col>
        -->
     <ion-col size="12" size-md="3">
          <mat-form-field class="w-100 mat-height40 mat-input-style">
              <mat-select placeholder="Select Review" [(ngModel)]="selectedReviewGlobalDashboardID"
                (selectionChange)="onChangeGolbalDashboardReview()">
                <mat-option *ngFor="let item of listofReviewNamesActiveAndCompleted" [value]="item.id">
                  {{item.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
      </ion-col>
    </ion-row>
    <ion-row class="mt-10 phi-flex-between phi-align-center animated-row">

      <!-- LEFT SIDE (Card) -->
      <ion-col size="12" size-md="3">
        <ng-container
          *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'; else emptyCol">
          <div class="card expense-card h-100 slide-in-left" [class.disabled-card]="reviewCounterCount <= 0"
            (click)="reviewCounterCount > 0 && dashboardPopups()">
            <div class="phi-flex-center phi-gap-12">
              <mat-icon class="expense-icon">receipt_long</mat-icon>
              <div class="text-center three-review-center">
                <p class="fs-12 font_semibold expense-title">360 degree created by HR</p>
                <p class="mt-5 fs-12 font_bold Cerulean-black cp expense-count">
                  <!-- {{ reviewCounterCount }} -->
                    {{reviewName}}
                </p>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- EMPTY PLACEHOLDER -->
        <ng-template #emptyCol>
          <div style="width:100%; height:1px;"></div>
        </ng-template>
      </ion-col>

      <!-- RIGHT SIDE (Filters) -->
      <!-- <ion-col size="12" size-md="9" class="phi-flex-end slide-in-right">
        <ion-col size="12" size-md="3">
          <div class="phi-flex-center phi-gap-10 flex-wrap">
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <mat-select placeholder="Select Year" [(ngModel)]="selectedYear"
                (selectionChange)="onChange360DashboardYear($event.value)">
                <mat-option *ngFor="let item of yearsOfCompany"
                  [value]="item.year">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <mat-select placeholder="Select Review" [(ngModel)]="selectedReviewGlobalDashboardID"
                (selectionChange)="onChangeGolbalDashboardReview()">
                <mat-option *ngFor="let item of listofReviewNamesActiveAndCompleted" [value]="item.id">
                  {{item.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ion-col>
      </ion-col> -->
    </ion-row>


    <div *ngIf="!isShowDashboardToHR && loggedInUserRole == 'HR Admin'">
      <p class="fs-14 fs_12ForMobile font_semibold" *ngIf="selectedReviewGlobalDashboardID">You don't have access of
        dashboard for this
        360</p>
    </div>
    <div [hidden]="!isShowDashboardToHR && loggedInUserRole == 'HR Admin'">
      <ion-row>
        <!-- Competency Wise -->
        <ion-col size="12" size-md="6">
          <div class="graphs mt-20">
            <ion-row class="justify-content-center">
              <ion-col size="6" size-lg="7">
                <div class="fs-16 fs_14ForMobile font_bold">Competency Wise</div>
              </ion-col>
              <ion-col size="6" size-lg="5">
                <div class="d-flex graph-icon">
                  <span (click)="switchCompetencyWiseGraphType('bar')">
                    <img *ngIf="competencyWiseIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="">
                    <img *ngIf="competencyWiseIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
                  </span>

                  <span (click)="switchCompetencyWiseTable()">
                    <img *ngIf="!competencyWiseTable" src="././assets/icon/tableIcon.svg" alt="">
                    <img *ngIf="competencyWiseTable" src="././assets/icon/TableIconActive.svg" alt="">
                  </span>

                  <span (click)="switchCompetencyWiseGraphType('line')">
                    <img *ngIf="competencyWiseIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt="">
                    <img *ngIf="competencyWiseIcon == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
                  </span>

                  <span (click)="downloadCompetencyWiseGraph()" class="cp"><img src="././assets/icon/downloadIcon.svg"
                      alt=""></span>
                </div>
              </ion-col>
            </ion-row>
            <div class="mt-10 mb-10">
              <ion-row>
                <ion-col size-sm="6" size-md="6" size-lg="3" size-xs="6">
                  <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                    <mat-select placeholder="Select Year" [(ngModel)]="selectedYearCompetencyWise"
                      (selectionChange)="reviewNamesActiveAndCompletedCompetencyWise()">
                      <mat-option *ngFor="let item of yearsOfCompany"
                        [value]="item.year">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="6" size-md="6" size-lg="4" size-xs="6">
                  <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                    <mat-select placeholder="Select Review" [(ngModel)]="selectedReviewCompetencyWiseID"
                      (selectionChange)="getBandNamesReviewId()">
                      <mat-option *ngFor="let item of listofReviewNamesActiveAndCompletedCompetencyWise"
                        [value]="item.id">{{item.name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
                <ng-container
                  *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
                  <ion-col size-sm="6" size-md="6" size-lg="4" size-xs="6">
                    <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                      <mat-select placeholder="Select Band" [(ngModel)]="selectedBandCompetencyWiseGraph"
                        (selectionChange)="getEmpNamesBy360AndBands()">
                        <mat-option *ngFor="let item of bandlistForCompetencyWiseGraph"
                          [value]="item">{{item}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ion-col>
                  <ion-col size-sm="6" size-md="6" size-lg="4" size-xs="6">
                    <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                      <mat-select placeholder="Select Employee" [(ngModel)]="selectedEmployeeCompetencyWiseGraph"
                        (selectionChange)="getCompletionStatusGraph()">
                        <mat-option *ngFor="let item of empListForCompetencyWiseGraph"
                          [value]="item.id">{{item.name}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ion-col>
                </ng-container>
              </ion-row>
            </div>
            <div [ngClass]="{'dispNone' : competencyWiseTable}">
              <div id="competencyWiseGraph" style="height: 400px;"></div>
            </div>
            <div [ngClass]="{'dispNone' : !competencyWiseTable}" id="competencyWiseTable">
              <div class="dashboardGraphTable">
                <table>
                  <thead>
                    <tr>
                      <th>Competency</th>
                      <th>Score</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of competencyWiseGraphData">
                      <td>{{item.name}}</td>
                      <td>{{item.value}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </ion-col>

        <!-- Question Wise -->
        <ion-col size="12" size-md="6">
          <div class="graphs mt-20">
            <ion-row class="justify-content-center">
              <ion-col size="6" size-lg="7">
                <div class="fs-16 fs_14ForMobile font_bold">Question Wise</div>
              </ion-col>
              <ion-col size="6" size-lg="5">
                <div class="d-flex graph-icon">
                  <span (click)="switchQuestionWiseGraphType('bar')">
                    <img *ngIf="questionWiseIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="">
                    <img *ngIf="questionWiseIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
                  </span>

                  <span (click)="switchQuestionWiseTable()">
                    <img *ngIf="!questionWiseTable" src="././assets/icon/tableIcon.svg" alt="">
                    <img *ngIf="questionWiseTable" src="././assets/icon/TableIconActive.svg" alt="">
                  </span>

                  <span (click)="switchQuestionWiseGraphType('line')">
                    <img *ngIf="questionWiseIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt="">
                    <img *ngIf="questionWiseIcon == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
                  </span>

                  <span class="cp" (click)="downloadQuestionWiseGraph()"><img src="././assets/icon/downloadIcon.svg"
                      alt=""></span>
                </div>
              </ion-col>
            </ion-row>
            <div class="mt-10 mb-10">
              <ion-row>
                <ion-col size-sm="6" size-md="6" size-lg="4" size-xs="6">
                  <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                    <mat-select placeholder="Select Year" [(ngModel)]="selectedYearQuestionWise"
                      (selectionChange)="reviewNamesActiveAndCompletedQuestionWise()">
                      <mat-option *ngFor="let item of yearsOfCompany"
                        [value]="item.year">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>

                <ion-col size-sm="6" size-md="6" size-lg="4" size-xs="6">
                  <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                    <mat-select placeholder="Select Review" [(ngModel)]="selectedReviewQuestionWiseID"
                      (selectionChange)="getCompetencyNamesBy360Id()">
                      <mat-option *ngFor="let item of listofReviewNamesActiveAndCompletedQuestionWise"
                        [value]="item.id">{{item.name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>

                <ion-col size-sm="6" size-md="6" size-lg="4" size-xs="6">
                  <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                    <mat-select placeholder="Select Competency" [(ngModel)]="selectedCompetencyQuestionWise"
                      (selectionChange)="getEmpNamesBy360IdQuestionWiseGraph()">
                      <mat-option *ngFor="let item of competencylistForQuestionWiseGraph"
                        [value]="item.id">{{item.competencyName}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>

                <ion-col size-sm="6" size-md="6" size-lg="4" size-xs="6"
                  *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
                  <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                    <mat-select placeholder="Select Employee" [(ngModel)]="selectedEmployeeQuestionWiseGraph"
                      (selectionChange)="getQuestionWiseStatusGraph()">
                      <mat-option *ngFor="let item of listOfEmpForQuestionWise"
                        [value]="item.id">{{item.name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
              </ion-row>
            </div>
            <div [ngClass]="{'dispNone' : questionWiseTable}">
              <div id="questionWiseGraph" style="height: 400px;"></div>
            </div>
            <div [ngClass]="{'dispNone' : !questionWiseTable}" id="questionWiseTable">
              <div class="dashboardGraphTable">
                <table>
                  <thead>
                    <tr>
                      <th>Question</th>
                      <th>Score</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of questionWiseGraphData">
                      <td>{{item.name}}</td>
                      <td>{{item.value}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </ion-col>

        <!-- Stakeholder Wise -->
        <ion-col size="12" size-md="6">
          <div class="graphs mt-20">
            <ion-row class="justify-content-center">
              <ion-col size="6" size-lg="7">
                <div class="fs-16 fs_14ForMobile font_bold">Stakeholder Wise</div>
              </ion-col>
              <ion-col size="6" size-lg="5">
                <div class="d-flex graph-icon">
                  <span (click)="switchStakeholderWiseGraphType('bar')">
                    <img *ngIf="stakeholderWiseIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="">
                    <img *ngIf="stakeholderWiseIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
                  </span>

                  <span (click)="switchStakeholderWiseTable()">
                    <img *ngIf="!stakeholderWiseTable" src="././assets/icon/tableIcon.svg" alt="">
                    <img *ngIf="stakeholderWiseTable" src="././assets/icon/TableIconActive.svg" alt="">
                  </span>

                  <span (click)="switchStakeholderWiseGraphType('line')">
                    <img *ngIf="stakeholderWiseIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt="">
                    <img *ngIf="stakeholderWiseIcon == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
                  </span>

                  <span class="cp" (click)="downloadStakeholderWiseGraph()"><img src="././assets/icon/downloadIcon.svg"
                      alt=""></span>
                </div>
              </ion-col>
            </ion-row>
            <div class="mt-10 mb-10">
              <ion-row>
                <ion-col size-sm="6" size-md="6" size-lg="4" size-xs="6">
                  <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                    <mat-select placeholder="Select Year" [(ngModel)]="selectedYearStakeholderWise"
                      (selectionChange)="reviewNamesActiveAndCompletedSatkeholderWise()">
                      <mat-option *ngFor="let item of yearsOfCompany"
                        [value]="item.year">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="6" size-md="6" size-lg="4" size-xs="6">
                  <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                    <mat-select placeholder="Select Review" [(ngModel)]="selectedReviewSatkeholderWiseID"
                      (selectionChange)="getEmpNamesBy360IdStakeholderWiseGraph()">
                      <mat-option *ngFor="let item of listofReviewNamesActiveAndCompletedSatkeholderWise"
                        [value]="item.id">{{item.name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="6" size-md="6" size-lg="4" size-xs="6"
                  *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
                  <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                    <mat-select placeholder="Select Employee" [(ngModel)]="selectedEmployeeStakeholderWise"
                      (selectionChange)="getStakeholderWiseGraph()">
                      <mat-option *ngFor="let item of listOfEmpForStakeholderWise"
                        [value]="item.id">{{item.name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
              </ion-row>
            </div>
            <div [ngClass]="{'dispNone' : stakeholderWiseTable}">
              <div id="stakeholderWiseGraph" style=" height: 400px;"></div>
            </div>
            <div [ngClass]="{'dispNone' : !stakeholderWiseTable}" id="stakeholderWiseTable">
              <div class="dashboardGraphTable">
                <table>
                  <thead>
                    <tr>
                      <th>Stakeholder</th>
                      <th>Score</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of stakeholderWiseGraphData">
                      <td>{{item.name}}</td>
                      <td>{{item.value}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </ion-col>

        <!-- How did I fare in this 360 dashboard  -->
        <ion-col size="12" size-md="6">
          <div class="graphs mt-20">
            <ion-row class="justify-content-center">
              <ion-col size="6" size-lg="7">
                <div class="fs-16 fs_14ForMobile font_bold">How did I fare in this 360 dashboard</div>
              </ion-col>
              <ion-col size="6" size-lg="5">
                <div class="d-flex graph-icon">
                  <span (click)="switchHowDidIFareGraphType('bar')">
                    <img *ngIf="HowDidIFareIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="">
                    <img *ngIf="HowDidIFareIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
                  </span>

                  <span (click)="switchHowDidIFareGraphType('pie')">
                    <img *ngIf="HowDidIFareIcon != 'pie'" src="././assets/icon/pieChartIcon.svg" alt="">
                    <img *ngIf="HowDidIFareIcon == 'pie'" src="././assets/icon/PieIconActive.svg" alt="">
                  </span>

                  <span (click)="switchHowDidIFareTable()">
                    <img *ngIf="!HowDidIFareTable" src="././assets/icon/tableIcon.svg" alt="">
                    <img *ngIf="HowDidIFareTable" src="././assets/icon/TableIconActive.svg" alt="">
                  </span>

                  <span (click)="switchHowDidIFareGraphType('line')">
                    <img *ngIf="HowDidIFareIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt="">
                    <img *ngIf="HowDidIFareIcon == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
                  </span>

                  <span class="cp" (click)="downloadHowDidIFareGraph()"><img src="././assets/icon/downloadIcon.svg"
                      alt=""></span>
                </div>
              </ion-col>
            </ion-row>
            <div class="mt-10 mb-10">
              <ion-row>
                <ion-col size-sm="6" size-md="6" size-lg="4" size-xs="6">
                  <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                    <mat-select placeholder="Select Year" [(ngModel)]="selectedYearHowDidFareWise"
                      (selectionChange)="reviewNamesActiveAndCompletedHowDidIFareWise()">
                      <mat-option *ngFor="let item of yearsOfCompany"
                        [value]="item.year">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="6" size-md="6" size-lg="4" size-xs="6">
                  <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                    <mat-select placeholder="Select Review" [(ngModel)]="selectedReviewHowDidFareWiseID"
                      (selectionChange)="getHowDidIFareGraph()">
                      <mat-option *ngFor="let item of listofReviewNamesActiveAndCompletedHowDidIFareWise"
                        [value]="item.id">{{item.name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>

              </ion-row>
            </div>
            <div [ngClass]="{'dispNone' : HowDidIFareTable}">
              <div id="HowDidIFareDashboardGraph" style="height: 400px;"></div>
            </div>
            <div [ngClass]="{'dispNone' : !HowDidIFareTable}" id="HowDidIFareDashboardTable">
              <div class="dashboardGraphTable">
                <table>
                  <thead>
                    <tr>
                      <th>Employee Name</th>
                      <th>Final 360 Score</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of howDidIFareWiseGraphData">
                      <td>{{item.name}}</td>
                      <td>{{item.value}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>
        </ion-col>

        <!-- Top 2 vs Bottom 2 Analysis  -->
        <ion-col size="12">
          <div class="graphs mt-20">
            <ion-row class="justify-content-center">
              <ion-col size="6" size-lg="7">
                <div class="fs-16 fs_14ForMobile font_bold">Top 2 vs Bottom 2 Analysis</div>
              </ion-col>
              <ion-col size="6" size-lg="5">
                <div class="graph-icon">
                  <span class="cp" (click)="downloadTopVsBottomAnalysisGraph()"><img
                      src="././assets/icon/downloadIcon.svg" alt=""></span>
                </div>
              </ion-col>
            </ion-row>
            <div class="mt-10 mb-10">
              <ion-row>
                <ion-col size="6" size-md="3" size-lg="2">
                  <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                    <mat-select placeholder="Select Year" [(ngModel)]="selectedYearTopandBottom"
                      (selectionChange)="reviewNamesActiveAndCompletedTopandBottomWise()">
                      <mat-option *ngFor="let item of yearsOfCompany"
                        [value]="item.year">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
                <ion-col size="6" size-md="3" size-lg="2">
                  <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                    <mat-select placeholder="Select Review" [(ngModel)]="selectedReviewTopandBottomId"
                      (selectionChange)="getEmpNamesBy360IdTopandBottomWiseGraph()">
                      <mat-option *ngFor="let item of listofReviewNamesActiveAndCompletedTopandBottomWise"
                        [value]="item.id">{{item.name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
                <ion-col size="6" size-md="3" size-lg="2">
                  <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style"
                    *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
                    <mat-select placeholder="Select Employee" [(ngModel)]="selectedEmployeeForTopandBottom"
                      (selectionChange)="getTopVsBottomAnalysisGraph()">
                      <mat-option *ngFor="let item of listOfEmpForTopandBottomWise"
                        [value]="item.id">{{item.name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
                <ion-col size="12" size-md="3" size-lg="6">
                  <div class="float-right float_leftForMobile">
                    <label class="fs-14 fs_12ForMobile font_semibold">Select</label>
                    <mat-radio-group aria-label="Select an option" [(ngModel)]="istopandbottomAnalysis"
                      class="fs-14 fs_12ForMobile font_semibold d_flexForMobile radio_btn"
                      (change)="onTopandBottomChange($event)">
                      <mat-radio-button [value]="true">Top</mat-radio-button>
                      <mat-radio-button [value]="false" class="pl-10">Bottom</mat-radio-button>
                    </mat-radio-group>
                  </div>
                </ion-col>
              </ion-row>
            </div>
            <div id="topToBottomAnalysisGraph" style="height: 400px;"></div>
          </div>
        </ion-col>

        <!-- Spider Web  -->
        <ion-col size="12">
          <div class="graphs mt-20">
            <ion-row class="justify-content-center">
              <ion-col size="6" size-lg="7">
                <div class="fs-16 fs_14ForMobile font_bold">Spider Web</div>
              </ion-col>
              <ion-col size="6" size-lg="5">
                <div class="graph-icon">
                  <span class="cp" (click)="downloadSpiderWebGraph()"><img src="././assets/icon/downloadIcon.svg"
                      alt=""></span>
                </div>
              </ion-col>
            </ion-row>
            <div class="mt-10 mb-10">
              <ion-row>
                <ion-col size="6" size-md="3" size-lg="2">
                  <div>
                    <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                      <mat-select placeholder="Select Year" [(ngModel)]="selectedYearSpiderWeb"
                        (selectionChange)="reviewNamesActiveAndCompletedSpiderGraph()">
                        <mat-option *ngFor="let item of yearsOfCompany"
                          [value]="item.year">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </ion-col>
                <ion-col size="6" size-md="3" size-lg="2">
                  <div>

                    <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                      <mat-select placeholder="Select Review" [(ngModel)]="selectedReviewSpidergraphId"
                        (selectionChange)="getEmpNamesBy360IdSpiderGraph()">
                        <mat-option *ngFor="let item of listofReviewNamesActiveAndCompletedSpiderGraph"
                          [value]="item.id">{{item.name}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </ion-col>
                <ion-col size="6" size-md="3" size-lg="2">
                  <div
                    *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
                    <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                      <mat-select placeholder="Select Employee" [(ngModel)]="selectedEmployeeForSpiderGraph"
                        (selectionChange)="getSpiderWebGraph()">
                        <mat-option *ngFor="let item of listOfEmpForSpiderGraph"
                          [value]="item.id">{{item.name}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </ion-col>
              </ion-row>
            </div>
            <div id="spiderWebGraph" style=" height: 400px;"></div>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>

  <!-- --------------------------------------360 Review Master------------------------------------->

  <div class="container" *ngIf="selectedTypeTabName == '360 Review Master'">
    <div class="cardBox mb-20 mt-10">
      <div class="headingOfShowBox font_medium fs-14 fs_12ForMobile">
        <ion-row class="p-0">
          <ion-col size="12">
            <div class="font_bold fs-14 fs_12ForMobile ml-5">360 Review</div>
          </ion-col>
        </ion-row>
      </div>
      <ion-row class="p-10">
        <ion-col size-sm="6" size-md="3" size-lg="2" size-xs="6">
          <div class="formLabelSemiBoldfs14 mb-5">Year</div>
          <div class="verticle-center">
            <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
              <mat-select placeholder="Select Year" [(ngModel)]="selectedYear" (selectionChange)="getAll360()">
                <mat-option *ngFor="let item of yearsOfCompany"
                  [value]="item.year">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ion-col>
      </ion-row>
    </div>

    <ion-row class="ion-justify-content-end">
      <ion-col size="auto" class="ion-text-end">
        <!-- Refresh Icon -->
        <span class="ml-5 fs-20 material-icons btn-reset" style="cursor:pointer;" [class.clicked]="isClicked"
          (click)="resetGrid(); isClicked = true" (animationend)="isClicked = false">
          refresh
        </span>
      </ion-col>
    </ion-row>


    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="cardBox p-20 mt-10">

          <mat-sidenav-container style="height: 100%;">
            <!-- Main Content with AG Grid -->
            <mat-sidenav-content>
              <ag-grid-angular  style="width: 100%; height: 400px;" class="ag-theme-quartz" [rowData]="listof360Review"
                [columnDefs]="listof360ReviewColumnDef" [gridOptions]="gridOptions" [defaultColDef]="defaultColDef"
                (rowClicked)="onRowClicked($event)" (cellClicked)="onCelledClicked($event)" [pagination]="pagination"
                [paginationPageSize]="paginationPageSize" [paginationPageSizeSelector]="paginationPageSizeSelector"
                [detailRowAutoHeight]="detailRowAutoHeight" (firstDataRendered)="onFirstDataRendered($event)"
                (gridReady)="onGridReady($event)" (selectionChanged)="onSelectionChanged()" rowSelection="multiple"
                [localeText]="{ noRowsToShow: 'No Data Found' }">
              </ag-grid-angular>
            </mat-sidenav-content>

            <!-- Right Side Sidenav -->
            <!-- <mat-sidenav #detailsPanel mode="over" position="end" [(opened)]="isDetailsOpen" class="details-panel">
              <div class="details-header">
                <h2>360 Review Details</h2>
                <button mat-icon-button (click)="closeDetails()">
                  <mat-icon class="close-icon">close</mat-icon>
                </button>
              </div>
            
              <div class="details-content" *ngIf="selectedRow">
                <mat-card class="detail-card" *ngFor="let col of listof360ReviewColumnDefCopyForDailog">
                  <mat-card-content>
                    <div class="detail-row">
                      <mat-icon class="detail-icon">trending_flat</mat-icon>
                      <div class="detail-text">
              
                        <span class="detail-label">{{ col.headerName }} </span>
              
                        <ng-container [ngSwitch]="col.field">
              
                          <span *ngSwitchCase="'reviewName'" 
                                class="clickable-name"
                                (click)="onClickEssName(selectedRow)">
                            {{ selectedRow[col.field] }}
                          </span>
              
                          <span *ngSwitchCase="'reviewStatus'" 
                                class="status-badge"
                                [ngClass]="{
                                  'completed': selectedRow[col.field] === 'Completed',
                                  'active': selectedRow[col.field] === 'Active'
                                }">
                            {{ selectedRow[col.field] }}
                          </span>
              
                          <span *ngSwitchCase="'startDate'">
                            {{ formatDate(selectedRow[col.field]) }}
                          </span>
              
                          <span *ngSwitchCase="'endDate'">
                            {{ formatDate(selectedRow[col.field]) }}
                          </span>
              
                          <span *ngSwitchCase="'year'">
                            {{ selectedRow.fromYear }} - {{ selectedRow.toYear }}
                          </span>
              
                          <ng-container *ngSwitchDefault>
                            <span *ngIf="selectedRow[col.field]">
                              {{ selectedRow[col.field] }}
                            </span>
                          </ng-container>
                          
              
                        </ng-container>
              
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
              
              
            </mat-sidenav> -->
          </mat-sidenav-container>

          <!-- <div class="table-container">
            <table>
              <thead>
                <tr>
                  <th class="w1" *ngIf="!isShowCheckBox && !mobileResponsiveService.hideForTabletAndBelow">
                    <section class="mat-checkbox-style">
                      <mat-checkbox [(ngModel)]="isAllSurveyMaster" class="fs-12 font_semibold "
                        (change)="onSelectAllSurveyMaster($event)" [checked]="isAllSurveyMaster" value="true"
                        (click)="$event.stopPropagation()" value=true></mat-checkbox>
                    </section>
                  </th>
                  <th class="fs-14 fs_12ForMobile font_bold cl-black">
                    <div class="verticle-center icon-style">Year
                      <div class="d-flex flex-column ml-10">
                        <i class="material-icons cp" (click)="onSortAssending('fromYear')">arrow_drop_up</i>
                        <i class="material-icons cp" (click)="onSortDesending('fromYear')">arrow_drop_down</i>
                      </div>
                    </div>
                  </th>
                  <th class="fs-14 fs_12ForMobile font_bold cl-black">
                    <div class="verticle-center icon-style">360 Review Name
                      <div class="d-flex flex-column ml-10">
                        <i class="material-icons cp" (click)="onSortAssending('essName')">arrow_drop_up</i>
                        <i class="material-icons cp" (click)="onSortDesending('essName')">arrow_drop_down</i>
                      </div>
                    </div>
                  </th>
                  <th class="fs-14 fs_12ForMobile font_bold cl-black">
                    <div class="verticle-center icon-style">Start date
                      <div class="d-flex flex-column ml-10">
                        <i class="material-icons cp" (click)="onSortAssending('startDate')">arrow_drop_up</i>
                        <i class="material-icons cp" (click)="onSortDesending('startDate')">arrow_drop_down</i>
                      </div>
                    </div>
                  </th>
                  <th class="fs-14 fs_12ForMobile font_bold cl-black">
                    <div class="verticle-center icon-style">End date
                      <div class="d-flex flex-column ml-10">
                        <i class="material-icons cp" (click)="onSortAssending('endDate')">arrow_drop_up</i>
                        <i class="material-icons cp" (click)="onSortDesending('endDate')">arrow_drop_down</i>
                      </div>
                    </div>
                  </th>
                  <th class="fs-14 fs_12ForMobile font_bold cl-black">
                    <div class="verticle-center icon-style">Status
                      <div class="d-flex flex-column ml-10">
                        <i class="material-icons cp" (click)="onSortAssending('status')">arrow_drop_up</i>
                        <i class="material-icons cp" (click)="onSortDesending('status')">arrow_drop_down</i>
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of listof360Review;let i = index">
                  <td *ngIf="!isShowCheckBox && !mobileResponsiveService.hideForTabletAndBelow">
                    <section class="mat-checkbox-style">
                      <mat-checkbox *ngIf="item.reviewStatus == 'Pending'" [(ngModel)]="item.isChecked"
                        class="fs-12 font_semibold " (change)="onSelectSingleSurveyMaster($event,item,i)"
                        [checked]="item.isChecked" value="true" (click)="$event.stopPropagation()"
                        value=true></mat-checkbox>
                    </section>
                  </td>
                  <td><span
                      class="fs-14 fs_12ForMobile font_regular">{{transformToYear(item?.fromYear,item?.toYear)}}</span>
                  </td>
                  <td><span class="fs-14 fs_12ForMobile font_regular yellow cp"
                      (click)="onClickEssName(item)">{{item.reviewName}}</span></td>
                  <td><span class="fs-14 fs_12ForMobile font_regular">{{item.startDate | date:'dd-MM-yyyy'}}</span></td>
                  <td><span class="fs-14 fs_12ForMobile font_regular">{{item.endDate | date:'dd-MM-yyyy'}}</span></td>
                  <td><span class="fs-14 fs_12ForMobile font_regular">{{item.reviewStatus}}</span></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="phi-flex-wrap-center-space-between-gap6 mb-5 mt-10">
            <div class="fs-14 fs_12ForMobile font_semibold mt-10">Showing {{(currentPage*4)-3}} to {{ (currentPage * 4)
              < totalCount ? (currentPage * 4) : totalCount }} of {{totalCount}} entries</div>
                <ul class="dt_pagination mt-10">
                  <li class="active fs-16 fs_14ForMobile font_regular">{{currentPage}}</li>
                  <span class="fs-14 fs_12ForMobile font_regular p-10 p_5pxForMobile">of {{totalNoOfPages}}</span>
                  <li class="fs-24 fs_18ForMobile cp" (click)="previousPageEss()"
                    [ngClass]="{'disableBtn': currentPage==1}">&lt;</li>
                  <li class="fs-24 fs_18ForMobile cp" (click)="nextPageEss()"
                    [ngClass]="{'disableBtn': currentPage>= totalNoOfPages}">&gt;</li>
                </ul>
            </div> -->
        </div>
      </ion-col>
    </ion-row>
  </div>

  <!-- ----------------------------------Participate in 360 Review------------------------------------->

  <div class="container" *ngIf="selectedTypeTabName == 'Participate in 360 Review'">
    <div class="mt-20">
      <ion-row>
        <ion-col size="6" size-md="2">
          <div>
            <div class="fs-14 fs_12ForMobile font_semibold">Year</div>
            <mat-form-field class="w-100 mt-5 mat-height40 mat-input-style">
              <mat-select placeholder="Select Year" [(ngModel)]="selectedYear" (selectionChange)="reviewNamesOfUser()">
                <mat-option *ngFor="let item of yearsOfCompany"
                  [value]="item.year">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ion-col>

        <ion-col size="6" size-md="2">
          <div class="fs-14 fs_12ForMobile font_semibold">360 Review</div>
          <mat-form-field class="w-100 mt-5 mat-height40 mat-input-style">
            <mat-select placeholder="Select Review" [(ngModel)]="selectedReviewID" (selectionChange)=" getReviewByID()">
              <mat-option *ngFor="let item of listofReviewNames" [value]="item.id">{{item.name}}</mat-option>
            </mat-select>
          </mat-form-field>
        </ion-col>

        <ion-col size="6" size-md="12" size-lg="2">
          <div class="fs-14 fs_12ForMobile font_semibold">Employee</div>
          <mat-form-field class="w-100 mt-5 mat-height40 mat-input-style">
            <mat-select placeholder="Select Employee" [(ngModel)]="selectedStakeholdersEmployeeId"
              (selectionChange)="changeStakeholderEmployee()">
              <mat-option *ngFor="let item of listofStakeHoldersEmployees" [value]="item.id">{{item.name}}</mat-option>
            </mat-select>
          </mat-form-field>
        </ion-col>
      </ion-row>
    </div>

    <div class="cardBox mb-20 mt-20">
      <div class="headingOfShowBox_two font_medium fs-14 fs_12ForMobile" [style.background-color]="buttonColorName">
        <ion-row class="p-0">
          <ion-col size="12">
            <div class="phi-flex-wrap-center-space-between phi-gap-12">
              <div class="font_bold fs-14 fs_12ForMobile">360 Review</div>
              <div class="w-sm-100 phi-flex-center ion-justify-content-between phi-gap-12">
                <div class="verticle-center mr-20">
                  <img class="w30" src="././assets/icon/mail_white_icon.svg" alt="createEmailBody">
                  <p class="ml-5">{{loggedInUserEmail}}</p>
                </div>
                <div class="icon-container">
                  <span class="material-icons mr-10 fs-16 fs_14ForMobile">info</span>
                  <div class="tooltip">
                    <div class="info-popup">
                      <div class="p-20">
                        <h4 class="font_semibold">Instructions</h4>
                        <div class="mt-10 ml-20">
                          <ul *ngFor="let data of intructionList">
                            <li class="fs-12 text_gray">{{data}}</li>
                          </ul>
                        </div>
                        <div class="info-table mt-20">
                          <table>
                            <thead>
                              <tr>
                                <th>Question type</th>
                                <th>Rating</th>
                                <th>Rating Definition</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let item of ratingList">
                                <td>{{item.questionType}}</td>
                                <td>{{item.rating}}</td>
                                <td>{{item.ratingDefinition}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ion-col>
        </ion-row>
      </div>
      <div class="p-10">
        <ion-row>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <ion-row>
              <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                <div class="formLabelSemiBoldfs14 mb-5">Start date</div>
                <div class="w-90 inputBoxDisabled opacity5">
                  {{selectedReviewStartDate | date:'dd-MM-yyyy'}}
                </div>
              </ion-col>

              <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                <div class="formLabelSemiBoldfs14 mb-5">End date</div>
                <div class="w-90 inputBoxDisabled opacity5">
                  {{selectedReviewEndDate | date:'dd-MM-yyyy'}}
                </div>
              </ion-col>
            </ion-row>

            <ion-row class="mt-20">
              <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                <div class="formLabelSemiBoldfs14 mb-5">Your Name</div>
                <div class="w-90 inputBoxDisabled opacity5">
                  {{loggedInUserName}}
                </div>
              </ion-col>

              <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                <div class="formLabelSemiBoldfs14 mb-5">Employee Name</div>
                <div class="w-90 inputBoxDisabled opacity5">
                  {{selectedStakeholdersEmployeeName}}
                </div>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>
      </div>
    </div>

    <div class="cardBox mb-20 mt-20">
      <div class="headingOfShowBox_two font_medium fs-14 fs_12ForMobile" [style.background-color]="buttonColorName">
        <ion-row class="p-0">
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <div class="font_bold fs-14 fs_12ForMobile">{{selectedReviewName}}</div>
          </ion-col>
        </ion-row>
      </div>
      <div class="p-10">



        <!-- // TODO: Participate in 360 Review Grid -->



        <ng-container *ngFor="let item of participatein360ReviewArrayList;let isLast=last">
          <ion-row class="mt-20">
            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
              <div class="fs-24 fs_18ForMobile">{{item.competencyName}}</div>
              <div class="table-container1 mt-20">
                <table>
                  <thead>
                    <tr>
                      <th>Sr. No</th>
                      <th>Questions</th>

                      <th *ngFor="let stakeholder of stakeholderRolesListByReviewID">{{stakeholder.roleType}}</th>
                      <th>Type (open/ rating)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let question of item.questions;let i=index">
                      <td>{{i+1}}</td>
                      <td>{{question.question}}</td>
                      <ng-container *ngIf="question?.answers">
                        <td *ngFor="let stakeholder of stakeholderRolesListByReviewID">

                          <mat-form-field *ngIf="question.questionType === 'Open Ended'"
                            class="w-100 mw-sm-250 mat-input-style">
                            <textarea matInput placeholder="Type text here" rows="1"
                              [disabled]="stakeholder.isSubmitted || reviewExpired"
                              [(ngModel)]="question?.answers[stakeholder?.roleType]" maxlength="510"></textarea>
                          </mat-form-field>

                          <ng-select *ngIf="question.questionType === 'Rating Based'" [clearable]="false"
                            class="w-100 mw-sm-250 mat mat-height40" placeholder="Select"
                            [(ngModel)]="question?.answers[stakeholder?.roleType]"
                            [disabled]="stakeholder.isSubmitted || reviewExpired">
                            <ng-option *ngFor="let rating of ratingBasedList" [value]="rating.rating">
                              {{ rating.rating }}
                            </ng-option>
                          </ng-select>
                        </td>
                      </ng-container>
                      <td>{{question.questionType}}</td>
                    </tr>
                    <tr *ngIf="isLast">

                      <td></td>
                      <td></td>
                      <td *ngFor="let stakeholder of stakeholderRolesListByReviewID">
                        <div style="display: flex;justify-content: center;align-items: center;">
                          <button [disabled]="stakeholder.isSubmitted ||reviewExpired"
                            [ngClass]="{'disableBtn' : stakeholder.isSubmitted}"
                            class="btn_one mb-10 fs-14 fs_12ForMobile" [style.background-color]="buttonColorName"
                            [ngStyle]="{ 'opacity': reviewExpired ? '0.5' : '1' }"
                            (click)="onClickSaveResponse(stakeholder.roleType,false,'save')">Save</button>
                          <button [disabled]="stakeholder.isSubmitted ||reviewExpired"
                            [ngClass]="{'disableBtn' : stakeholder.isSubmitted}"
                            class="btn_one mb-10 fs-14 fs_12ForMobile ml-10 m-sm-0"
                            [style.background-color]="buttonColorName"
                            [ngStyle]="{ 'opacity': reviewExpired ? '0.5' : '1' }"
                            (click)="onClickSaveResponse(stakeholder.roleType,true,'submit')">Submit</button>
                        </div>
                        <div *ngIf="stakeholder.submissionDate!=null" class="fs-14 fs_12ForMobile">Submitted on
                          {{stakeholder.submissionDate | date: 'dd-MM-yyyy | hh:mm a'}}</div>
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ion-col>
          </ion-row>
        </ng-container>
        <ion-row class="mt-20">
          <ion-col size-sm="6" size-md="2" size-lg="2" size-xs="6">
            <button [disabled]="isAllResponseSubmitted ||reviewExpired"
              [ngClass]="{'disableBtn' : isAllResponseSubmitted || participatein360ReviewArrayList.length == 0}"
              (click)="submitAllResponseOfReview(false,'save')" type="button" class="btn_one fs-14 fs_12ForMobile"
              [ngStyle]="{ 'opacity': reviewExpired ? '0.5' : '1' }" [style.background-color]="buttonColorName">Save All
              Responses</button>
          </ion-col>

          <ion-col size-sm="6" size-md="2" size-lg="2" size-xs="6">
            <button [disabled]="isAllResponseSubmitted || reviewExpired"
              [ngClass]="{'disableBtn' : isAllResponseSubmitted || participatein360ReviewArrayList.length == 0}"
              (click)="submitAllResponseOfReview(true,'submit')" type="button"
              class="btn_one fs-14 fs_12ForMobile ml-20" [ngStyle]="{ 'opacity': reviewExpired ? '0.5' : '1' }"
              [style.background-color]="buttonColorName">Submit
              All Responses</button>
          </ion-col>
        </ion-row>
      </div>
    </div>
  </div>

  <!-- --------------------------------------Reports------------------------------------->

  <div class="container" *ngIf="selectedTypeTabName == 'Reports'">
    <ion-row class="pl-0 pt-5 pb-5 pr-5">
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="pl-0 pt-5 pb-5 pr-5">
        <div class="d-flex subTabBtnGroup">
          <button [ngClass]="{'activeReportsSubTabBtn': selectedSubTab === 'A-Z report'}"
            (click)="showScoreCardReport('A-Z report')" type="button"
            class="ReportsSubTabBtn center-content fs-12 mr-5">
            <span class="displayContent">A-Z report</span>
          </button>

          <button [ngClass]="{'activeReportsSubTabBtn': selectedSubTab === 'Trend analysis report'}"
            (click)="showScoreCardReport('Trend analysis report')" type="button"
            class="ReportsSubTabBtn center-content fs-12 mr-5">
            <span class="displayContent">Trend analysis report</span>
          </button>

          <button [ngClass]="{'activeReportsSubTabBtn': selectedSubTab === 'Score given by you report'}"
            (click)="showScoreCardReport('Score given by you report')" type="button"
            class="ReportsSubTabBtn center-content fs-12 mr-5">
            <span class="displayContent">Score given by you report</span>
          </button>

          <div class="isShowDesktopView">
            <button *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin'
          || loggedInUserRole == 'PHI Admin'" [ngClass]="{'activeReportsSubTabBtn': selectedSubTab === 'Dump Report'}"
              (click)="showScoreCardReport('Dump Report')" type="button"
              class=" ReportsSubTabBtn center-content fs-12 mr-5">
              <span class="displayContent">Dump Report</span>
            </button>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12" size-md="3" size-lg="2"
        *ngIf="selectedSubTab === 'A-Z report' || selectedSubTab === 'Dump Report'">
        <mat-form-field class="w-100 mat-height40 mat-input-style">
          <mat-select placeholder="Select Year" [(ngModel)]="selectedYear" (selectionChange)="reviewNamesOfUser()">
            <mat-option *ngFor="let item of yearsOfCompany"
              [value]="item.year">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
          </mat-select>
        </mat-form-field>
      </ion-col>

      <ion-col size="12" size-md="3" size-lg="2"
        *ngIf="selectedSubTab === 'A-Z report' || selectedSubTab === 'Dump Report' || selectedSubTab === 'Score given by you report'">
        <mat-form-field class="w-100 mat-height40 mat-input-style">
          <mat-select placeholder="Select Review" [(ngModel)]="selectedReviewID"
            (selectionChange)="onChangeReviewNameOfReport();getReviewByID()">
            <mat-option *ngFor="let item of listofReviewNamesActiveAndCompleted"
              [value]="item.id">{{item.name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </ion-col>

      <ion-col size="12" size-md="3" size-lg="2"
        *ngIf="selectedSubTab === 'A-Z report' || selectedSubTab === 'Dump Report'">
        <mat-form-field class="w-100 mat-height40 mat-input-style">
          <input matInput [matDatepicker]="fromDate" placeholder="DD/MM/YYYY" [disabled]="isDisabledDatePicker"
            [(ngModel)]="selectedReviewStartDate">
          <mat-datepicker-toggle matIconSuffix [for]="fromDate"></mat-datepicker-toggle>
          <mat-datepicker #fromDate></mat-datepicker>
        </mat-form-field>
      </ion-col>

      <ion-col size="12" size-md="3" size-lg="2"
        *ngIf="selectedSubTab === 'A-Z report' || selectedSubTab === 'Dump Report'">
        <mat-form-field class="w-100 mat-height40 mat-input-style">
          <input matInput [matDatepicker]="toDate" placeholder="DD/MM/YYYY" [disabled]="isDisabledDatePicker"
            [(ngModel)]="selectedReviewEndDate">
          <mat-datepicker-toggle matIconSuffix [for]="toDate"></mat-datepicker-toggle>
          <mat-datepicker #toDate></mat-datepicker>
        </mat-form-field>
      </ion-col>

      <ng-container></ng-container>
      <!-- dropdown for the Score given by you report-->

      <ion-col size="12" size-md="3" size-lg="3" class="isShowDesktopView" *ngIf="(selectedSubTab === 'A-Z report' || selectedSubTab === 'Score given by you report') &&
        (loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin')">
        <ng-multiselect-dropdown class="w-100" [placeholder]="'Select Employee'" [settings]="dropdownSettings"
          [(ngModel)]="selectedEmployeeForReport" (onSelect)="onChangegetReportData()"
          (onDeSelect)="onChangegetReportData()" (onSelectAll)="selectAllEmployee($event)"
          (onDeSelectAll)="onDeSelectAllEmployee()" [data]="listOfEmpForReports">
        </ng-multiselect-dropdown>
      </ion-col>
      <ion-col size="12" size-md="3" size-lg="2" class="isShowMobileView" *ngIf="(selectedSubTab === 'A-Z report' || selectedSubTab === 'Score given by you report') &&
      (loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin')">
        <mat-form-field class="w-100 mat-height40 mat-input-style">
          <mat-select placeholder="Select Employee" [(ngModel)]="selectedEmployeeForReport"
            (selectionChange)="onChangegetReportData()">
            <mat-option *ngFor="let item of listOfEmpForReports" [value]="item.id">{{item.name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </ion-col>
      <ion-col size="12" size-md="3" size-lg="2"
        *ngIf="(selectedSubTab === 'Trend analysis report') && (loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin') ||
      (selectedSubTab === 'Score given by you report') && (loggedInUserRole == 'Employee' || loggedInUserRole == 'HOD' || loggedInUserRole == 'Manager')">
        <mat-form-field class="w-100 mat-height40 mat-input-style">
          <mat-select placeholder="Select Employee" [(ngModel)]="selectedEmployeeForReportForTrendAnalysis"
            (selectionChange)="onChangegetReportData()">
            <mat-option *ngFor="let item of listOfEmpForReports" [value]="item.id">{{item.name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </ion-col>
      <ion-col size="12" size-md="6" size-lg="12" *ngIf="selectedSubTab === 'Score given by you report'">
        <ion-row class="ion-justify-content-end ion-align-items-center">
          <!-- Refresh Icon -->
          <span class="ml-5 fs-20 material-icons btn-reset" style="cursor:pointer; margin-right: 10px;"
            [class.clicked]="isClickedScoreGiven" (click)="resetGridScoreGiven(); isClickedScoreGiven = true"
            (animationend)="isClickedScoreGiven = false">
            refresh
          </span>

          <!-- Download Button -->
          <button class="materialBtnIcon black_color fs-14 fs_12ForMobile font_semibold"
            (click)="onClickDownlaodScoreGivenByYourReport()">
            <span class="material-icons">download</span>
          </button>
        </ion-row>
      </ion-col>

    </ion-row>

    <div [hidden]="!isShowDashboardToHR && loggedInUserRole == 'HR Admin'">

      <div *ngIf="selectedSubTab == 'A-Z report'">
        <ion-row>
          <ion-col size="12" size-md="12" size-lg="12">
            <div class="cardBox p-20">
              <ion-row class="ion-justify-content-end ion-align-items-center">
                <!-- Refresh Icon -->
                <ion-col size="auto" class="ion-text-end">
                  <span class="ml-5 fs-20 material-icons btn-reset" style="cursor:pointer;"
                    [class.clicked]="isClickedAZReport" (click)="resetGridAZReport(); isClickedAZReport = true"
                    (animationend)="isClickedAZReport = false">
                    refresh
                  </span>
                </ion-col>

                <!-- Download Button -->
                <ion-col size="auto" class="ion-text-end">
                  <button class="materialBtnIcon black_color fs-14 fs_12ForMobile font_semibold"
                    (click)="onClickDownlaodAtoZTable()">
                    <span class="material-icons">download</span>
                  </button>
                </ion-col>
              </ion-row>


              <div *ngFor="let item of AtoZReportListData; let i = index" class="atoz-section">
                <div class="section-header">
                  <h3 class="user-name"> <strong>{{ item.userName }}</strong></h3>
                </div>

                <ag-grid-angular class="ag-theme-quartz" [domLayout]="'autoHeight'" style="width: 100%;"
                  [rowData]="(atozGrids[i] && atozGrids[i].rows) ? atozGrids[i].rows : []"
                  [columnDefs]="(atozGrids[i] && atozGrids[i].columns) ? atozGrids[i].columns : []"
                  [defaultColDef]="defaultColDef" [gridOptions]="gridOptions"
                  [pinnedBottomRowData]="(atozGrids[i] && atozGrids[i].pinnedBottom) ? atozGrids[i].pinnedBottom : []"
                  (gridReady)="onGridReadyForAZReport($event, i)">
                </ag-grid-angular>

              </div>

            </div>
          </ion-col>
        </ion-row>
      </div>

      <div *ngIf="selectedSubTab == 'Trend analysis report'">
        <ion-row>
          <ion-col size="12">
            <div class="cardBox p-20">
              <ion-row>
                <ion-col size="12" class="d-flex justify-content-end align-items-center gap-2">
                  <!-- Refresh Button -->
                  <span class="fs-20 material-icons btn-reset cursor-pointer"
                    [class.clicked]="isClickedTrendAnalysisReport"
                    (click)="resetGridTrendAnalysis(); isClickedTrendAnalysisReport = true"
                    (animationend)="isClickedTrendAnalysisReport = false">
                    refresh
                  </span>

                  <!-- Download Button -->
                  <button class="materialBtnIcon black_color fs-14 fs_12ForMobile font_semibold"
                    (click)="onBtExportForTrendAnalysis('Trend_analysis_report')">
                    <span class="material-icons">download</span>
                  </button>
                </ion-col>
                <ion-col>
                  <mat-sidenav-container style="height: 100%;">
                    <mat-sidenav-content>
                      <ag-grid-angular style="width: 100%; height:216px;" class="ag-theme-quartz"
                        [rowData]="trendAnalysisListData" [columnDefs]="trendAnalysisReportColumnDef"
                        [gridOptions]="gridOptions" [defaultColDef]="defaultColDef"
                        (gridReady)="onGridReadyForTrendAnalysis($event)"
                        (cellClicked)="onRowClickedFortrendAnalysis($event)" [pagination]="pagination"
                        [paginationPageSize]="paginationPageSize"
                        [paginationPageSizeSelector]="paginationPageSizeSelector"
                        [detailRowAutoHeight]="detailRowAutoHeight" [localeText]="{ noRowsToShow: 'No Data Found' }">
                      </ag-grid-angular>
                    </mat-sidenav-content>
                    <!-- ✅ SINGLE RIGHT SIDE PANEL -->
                    <!-- <mat-sidenav #detailsPanel mode="over" position="end" [(opened)]="isDetailsOpen" class="details-panel">
                  
                      <div class="details-header">
                        <h2>Trend analysis report</h2>
                        <button mat-icon-button (click)="closeDetails()">
                          <mat-icon class="close-icon">close</mat-icon>
                        </button>
                      </div>
                  
                      <div class="details-content" *ngIf="selectedRow">
                        <mat-card class="detail-card" *ngFor="let col of ScoreGivenByYouReportColumnDef">
                          <mat-card-content>
                            <div class="detail-row">
                              <mat-icon class="detail-icon">trending_flat</mat-icon>
                              <div class="detail-text">
                                <span class="detail-label">{{ col.headerName }} </span>
                                <span *ngIf="selectedRow[col.field]">
                                  {{ selectedRow[col.field] }}
                                </span>
                              </div>
                            </div>
                          </mat-card-content>
                        </mat-card>
                      </div>
                    </mat-sidenav> -->

                  </mat-sidenav-container>
                  <!-- <div class="table-container">
                    <table id="Trend_analysis_report">
                      <thead>
                        <tr>
                          <th>Year</th>
                          <th>Name of 360 Review 22</th>
                          <th>Start Date</th>
                          <th>End Date</th>
                          <th>Final Score</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of trendAnalysisListData">
                          <td>{{transformToYear(item?.fromYear,item?.toYear)}}</td>
                          <td>{{item.reviewName}}</td>
                          <td>{{item.startDate | date:'dd-MM-yyyy'}}</td>
                          <td>{{item.endDate | date:'dd-MM-yyyy'}}</td>
                          <td>{{item.finalScore}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div> -->
                </ion-col>
                <!-- <ion-col size="12">
                <ion-col size="12">
                  <ng-select class="w-100 mw-sm-250 mat mat-height40" placeholder="Select here"
                    [(ngModel)]="selectedCompetencyForReport" (change)="getCompetencyTrendAnalysisReport()"
                    [clearable]="false">
                    <ng-option [value]="item.competencyName"
                      *ngFor="let item of competencyListData">{{item.competencyName}}</ng-option>
                  </ng-select>
                </ion-col>
                <div class="display-space-between mt-20">
                  <div class="fs-16 fs_14ForMobile font_semibold">Select Competency</div>
                  <div>
                    <span class="fs-20 material-icons btn-reset cursor-pointer"
                        [class.clicked]="isClicked"
                        (click)="resetGrid(); isClicked = true"
                        (animationend)="isClicked = false">
                    refresh
                  </span>
                    <button class="materialBtnIcon black_color fs-14 fs_12ForMobile font_semibold"
                      (click)="onClickDownloadScoresOfSurveys('Trend_analysis_report_select_competency')">
                      <span class="material-icons">download</span>
                    </button>
                  </div>
                </div>
              </ion-col> -->
                <ion-col size="12">
                  <ion-col size="12">
                    <div class="fs-16 fs_14ForMobile font_semibold">
                      Select Competency
                    </div>

                  </ion-col>

                  <!-- Flex container -->
                  <div class="d-flex justify-content-between align-items-center mt-20">
                    <!-- Left Side -->
                    <ng-select class="w-100 mw-sm-250 mat mat-height40" placeholder="Select here"
                      [(ngModel)]="selectedCompetencyForReport" (change)="getCompetencyTrendAnalysisReport()"
                      [clearable]="false">
                      <ng-option [value]="item.competencyName" *ngFor="let item of competencyListData">
                        {{item.competencyName}}
                      </ng-option>
                    </ng-select>
                    <!-- Right Side -->
                    <div class="d-flex align-items-center gap-2">
                      <!-- Refresh -->
                      <span class="fs-20 material-icons btn-reset cursor-pointer" [class.clicked]="isClickedCompetency"
                        (click)="resetGridCompetency(); isClickedCompetency = true"
                        (animationend)="isClickedCompetency = false">
                        refresh
                      </span>

                      <!-- Download -->
                      <button class="materialBtnIcon black_color fs-14 fs_12ForMobile font_semibold"
                        (click)="onBtExport('Trend_analysis_report_select_competency')">
                        <span class="material-icons">download</span>
                      </button>
                    </div>
                  </div>
                </ion-col>

                <ion-col size="12" size-lg="12">
                  <mat-sidenav-container style="height: 100%;">
                    <mat-sidenav-content>
                      <ag-grid-angular style="width: 100%; height:216px;" class="ag-theme-quartz"
                        [rowData]="competencyWiseTrendAnalysisReport" [columnDefs]="trendAnalysisCompetencyColumnDef"
                        [gridOptions]="gridOptions" [defaultColDef]="defaultColDef" (gridReady)="onGridReady($event)"
                        (cellClicked)="onRowClickedFortrendAnalysisCompetency($event)" [pagination]="pagination"
                        [paginationPageSize]="paginationPageSize"
                        [paginationPageSizeSelector]="paginationPageSizeSelector"
                        [detailRowAutoHeight]="detailRowAutoHeight" [localeText]="{ noRowsToShow: 'No Data Found' }">
                      </ag-grid-angular>
                    </mat-sidenav-content>
                    <!-- ✅ SINGLE RIGHT SIDE PANEL -->
                    <!-- <mat-sidenav #detailsPanel mode="over" position="end" [(opened)]="isDetailsCompetencyOpen" class="details-panel">
                  
                      <div class="details-header">
                        <h2>Trend analysis report</h2>
                        <button mat-icon-button (click)="closeDetails()">
                          <mat-icon class="close-icon">close</mat-icon>
                        </button>
                      </div>
                  
                      <div class="details-content" *ngIf="selectedRow">
                        <mat-card class="detail-card" *ngFor="let col of trendAnalysisCompetencyColumnDef">
                          <mat-card-content>
                            <div class="detail-row">
                              <mat-icon class="detail-icon">trending_flat</mat-icon>
                              <div class="detail-text">
                                <span class="detail-label">{{ col.headerName }} </span>
                                <span *ngIf="selectedRow[col.field]">
                                  {{ selectedRow[col.field] }}
                                </span>
                              </div>
                            </div>
                          </mat-card-content>
                        </mat-card>
                      </div>
                    </mat-sidenav> -->

                  </mat-sidenav-container>

                  <!-- <div class="table-container mt-10">
                    <table id="Trend_analysis_report_select_competency">
                      <thead>
                        <tr>
                          <th>Year</th>
                          <th>Competency</th>
                          <th>Score</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of competencyWiseTrendAnalysisReport">
                          <td>{{transformToYear(item?.fromYear,item?.toYear)}}</td>
                          <td>{{item.competencyName}}</td>
                          <td>{{item.score}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div> -->
                </ion-col>
              </ion-row>
            </div>
          </ion-col>
        </ion-row>
      </div>
      <!-- {{getScoreGivenByYouReportListData |json}} -->
      <div *ngIf="selectedSubTab == 'Score given by you report'">

        <ion-row *ngFor="let item of getScoreGivenByYouReportListData">
          <ion-col size="12">
            <div class="cardBox">
              <div class="cardBox-Heading">
                <span class="fs-14 font_semibold">
                  Score Given by You : {{item.stakeholderName}}
                </span>
              </div>

              <div class="p-20" *ngFor="let relation of item.relations">
                <ion-row>
                  <ion-col size="12" size-md="4">
                    <div class="fs-14 text_grey font_semibold">
                      NAME FOR WHOM 360 IS FILLED
                    </div>
                    <div class="fs-14 yellow font_semibold mt-10">
                      {{relation.empName}}
                    </div>
                  </ion-col>
                  <ion-col size="12" size-md="4">
                    <div class="fs-14 text_grey font_semibold">
                      RELATIONSHIP TO PERSON
                    </div>
                    <div class="fs-14 yellow font_semibold mt-10">
                      {{relation.relation}}
                    </div>
                  </ion-col>
                </ion-row>

                <!-- <ag-grid-angular
                  style="width: 100%; height: 300px;"
                  class="ag-theme-alpine mt-20"
                  [rowData]="prepareGridData(relation.competency)"
                  [columnDefs]="ScoreGivenByYouReportColumnDef"
                  [defaultColDef]="defaultColDef"
                  domLayout="autoHeight"
                >
                </ag-grid-angular> -->

                <mat-sidenav-container style="height: 100%;">
                  <!-- Main Content with AG Grid -->

                  <mat-sidenav-content>
                    <ag-grid-angular style="width: 100%; height:261px;" class="ag-theme-quartz"
                      [rowData]="prepareGridData(relation.competency)" [columnDefs]="ScoreGivenByYouReportColumnDef"
                      [gridOptions]="gridOptionsScoreGiven" [defaultColDef]="defaultColDef"
                      (gridReady)="onGridReadyForScoreGiven($event)"
                      (cellClicked)="onRowClickedForScoreGivenBy($event, relation)" [pagination]="pagination"
                      [paginationPageSize]="paginationPageSize"
                      [paginationPageSizeSelector]="paginationPageSizeSelector"
                      [detailRowAutoHeight]="detailRowAutoHeight" [localeText]="{ noRowsToShow: 'No Data Found' }">
                    </ag-grid-angular>
                  </mat-sidenav-content>
                  <!-- Right Side Sidenav -->


                </mat-sidenav-container>
              </div>
            </div>
          </ion-col>
        </ion-row>
        <!-- <ion-row > -->
      </div>

      <div *ngIf="selectedSubTab == 'Dump Report'">
        <ion-row>
          <ion-col size="9" size-md="7" size-lg="3">
            <mat-form-field class="mat-height40 w-100 mat-input-style">
              <mat-icon matPrefix>search</mat-icon>
              <input matInput type="search" placeholder="Search" [(ngModel)]="dumpReportSearchString"
                (input)="onSearchDumpReport($event)">
            </mat-form-field>
          </ion-col>
          <ion-col size="3" size-md="4" size-lg="9">
            <button class="materialBtnIcon black_color fs-14 fs_12ForMobile font_semibold float-right"
              (click)="onClickDownloadScoresOfSurveys('Dump_Report')">
              <span class="material-icons">download</span>
            </button>
          </ion-col>
        </ion-row>



        <div class="cardBox p-20 mt-10">

          <!-- <pre>{{rowDataForDumpReport |json}}</pre> -->
          <!-- <br> -->
          <!-- --------------------------------------------- -->
          <!-- <pre>{{getDumpReportListData |json}}</pre> -->
          <ion-row>
            <ion-col size="12">
              <!-- <mat-sidenav-container style="height: 100%;">
                <mat-sidenav-content>
                  <ag-grid-angular
                    style="width: 100%; height:500px;"
                    class="ag-theme-quartz"
                    [rowData]="rowDataForDumpReport"
                    [columnDefs]="columnDefsForDumpReport"
                    [gridOptions]="gridOptions"
                    [defaultColDef]="defaultColDefForDumpReport"
                    (gridReady)="onGridReadyForDumpReport($event)"
                    (filterChanged)="updatePinnedBottomRow()" 
                    [detailRowAutoHeight]="detailRowAutoHeight"
                    [pinnedBottomRowData]="pinnedBottomRowData"
                    [localeText]="{ noRowsToShow: 'No Data Found' }"
                  >
                  </ag-grid-angular>
                </mat-sidenav-content>
                
              </mat-sidenav-container> -->


              <div class="table-container mt-20">
                <table id="Dump_Report">
                  <thead>
                    <tr>
                      <th></th>
                      <th></th>
                      <th></th>
                      <ng-container *ngFor="let column of getDumpReportListData?.[0]?.columns">
                        <th [attr.colspan]="getTotalColumnsForCompetency(column)">
                          {{ column.competencyName }}
                        </th>
                      </ng-container>
                    </tr>
                    <tr>
                      <td>Reviewer (list of all people for whom the selected was a P2P/Lead)</td>
                      <td>Feedback giver</td>
                      <td>Relation by reviewer and stakeholder (x)</td>
                      <ng-container *ngFor="let column of getDumpReportListData?.[0]?.columns">
                        <ng-container *ngFor="let question of column.questions">
                          <ng-container *ngFor="let i of getQuestionScoreCount(column.competencyName, question)">
                            <th>{{ question }}</th>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                    </tr>
                  </thead>
                  <tbody>

                    <tr *ngFor="let feedback of getDumpReportListData?.[0]?.data">
                      <td>{{ feedback.receiverName }}</td>
                      <td>{{ feedback.feedbackGiverName }}</td>
                      <td>{{ feedback.relation }}</td>
                      <ng-container *ngFor="let column of getDumpReportListData?.[0]?.columns">
                        <ng-container *ngFor="let question of column.questions">
                          <ng-container *ngFor="let i of getQuestionScoreCount(column.competencyName, question)">
                            <td>

                              {{ getScore(feedback, column.competencyName, question) || '-' }}

                            </td>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="3"><strong>Total</strong></td>
                      <ng-container *ngFor="let column of getDumpReportListData?.[0]?.columns">
                        <ng-container *ngFor="let question of column.questions">
                          <ng-container *ngFor="let i of getQuestionScoreCount(column.competencyName, question)">
                            <td><strong>{{ getTotalScore(column.competencyName, question) }}
                              </strong></td>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </ion-col>
          </ion-row>
        </div>
      </div>

    </div>
  </div>
</ion-content>